import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  message: null,
  created_at: null,
  user_id: null,
  verification_status: null,
  document_upload_enabled: false,
  id: null,
  type: null,
};

const verificationSlice = createSlice({
  name: "verification",
  initialState,
  reducers: {
    setVerificationData: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearVerificationData: () => initialState,
  },
});

export const { setVerificationData, clearVerificationData } =
  verificationSlice.actions;
export default verificationSlice.reducer;
